module.exports = __webpack_public_path__ + "img/sv88.dd9dd71a.svg";